import { uniq } from 'lodash'

import rapidReviewInitialState from './state'

export default {
  addDocuments: (state, documents) => {
    state.documents = { ...state.documents, ...documents }
  },

  addDocumentMarkupLayerId: (state, { documentId, markupLayerId }) => {
    const doc = state.documents[documentId]
    const idx = doc.redaction_layer_ids.findIndex(
      (layerId) => layerId === markupLayerId
    )
    if (idx === -1) {
      doc.redaction_layer_ids.push(markupLayerId)
    }

    Object.assign(state.documents[documentId], doc)
  },

  addProcessingDocIds: (state, ids) => {
    state.processingDocIds = uniq([...state.processingDocIds, ...ids])
  },

  setCheckedDocIds: (state, ids) => {
    state.checkedDocIds = uniq(ids)
  },

  emptyDocuments: (state) => {
    state.documents = {}
  },

  incrementInfiniteId: (state) => {
    state.infiniteId += 1
  },

  incrementInfinitePage: (state) => {
    state.infinitePage += 1
  },

  setAutoSaveState: (state, val) => {
    state.autoSaveState = val
  },

  reinitializeState: (state) => {
    Object.assign(state, rapidReviewInitialState)
  },

  removeDocument: (state, id) => {
    delete state.documents[id]
  },

  removeProcessingDocIds: (state, ids) => {
    state.processingDocIds = state.processingDocIds.filter(
      (id) => !ids.includes(id)
    )
  },

  resetDocuments: (state) => {
    state.documents = {}
  },

  resetInfinitePage: (state) => {
    state.infinitePage = 1
  },

  setActiveDocId: (state, id) => {
    state.activeDocId = id
  },

  setAbility: (state, ability) => {
    state.rules = ability
  },

  setActiveFolder: (state, val) => {
    state.activeFolder = val
  },

  setActiveModal: (state, val) => {
    state.activeModal = val
  },

  setActiveReviewState: (state, val) => {
    state.activeReviewState = val
  },

  setActiveCheckAll: (state, val) => {
    state.activeCheckAll = val
  },

  setDocument: (state, document) => {
    state.documents[document.id] = document
  },

  setDocuments: (state, documents) => {
    state.documents = documents
  },

  setFolders: (state, folders) => {
    state.folders = [...new Set(folders)]
  },

  setChildFolders: (state, { folderId, folders }) => {
    for (const folder of state.folders) {
      if (folder.id === folderId) {
        folder.folders = folders
      }
    }
  },

  setFolderOptions: (state, folderOptions) => {
    state.folderOptions = folderOptions
  },

  setPrettyId: (state, val) => {
    state.prettyId = val
  },

  setRegexes: (state, regexes) => {
    state.regexes = regexes
  },

  setReviewStateCounts: (state, counts) => {
    state.reviewStateCounts = counts
  },

  setSearchTerm: (state, val) => {
    state.searchTerm = val
  },

  setSearchProcessIds: (state, obj) => {
    state.searchProcesses = { ...state.searchProcesses, ...obj }
  },

  uncheckDoc: (state, val) => {
    state.checkedDocIds = state.checkedDocIds.filter((id) => id !== val)
  },

  updateMarkupLayerUpdatedAtInState: (state, val) => {
    state.currentMarkupUpdatedAt = val
  },

  updateDocument: (state, { id, attrs }) => {
    state.documents[id] = Object.assign(state.documents[id], attrs)
  },

  setViewingSessionId: (state, val) => {
    state.viewingSessionId = val
  },

  setTotalDocCount: (state, val) => {
    state.totalDocCount = val
  },

  setRedactionReasons: (state, reasons = {}) => {
    state.redactionReasons = reasons
  }
}
